import React, { useState, useEffect } from "react";
import DocumentUpload from "../../layout/DocumentUpload";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import Loading from "../../components/Loading";
import NotFound from "../../layout/NotFound";
import LinkExpired from "../../layout/LinkExpired";
import { getVisaDetail } from "../../store/Visa/VisaAction";
import Navigation from "../../components/Navigation";
import Information from "../../components/Information";
// import AddOns from "../../layout/AddOns";

const TravellerNavigation = ({ selectedCurrency }) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const departureDate = searchParams.get("departureDate");
  const numTravellers = searchParams.get("numTravellers");
  const currentTravel = searchParams.get("currentTraveller");
  const sessionId = searchParams.get("sessionId");
  const [minSelectableDate, setMinSelectableDate] = useState("");
  const numOfTravellers = parseInt(numTravellers) || 1;
  const [currentTraveller, setCurrentTraveller] = useState(0);
  // const [numOfAddOns, setNumOfAddOns] = useState(0);
  // const [addOns, setAddOns] = useState({});


  useEffect(() => {
    setCurrentTraveller(parseInt(currentTravel));
  }, [currentTravel]);

  const dispatch = useDispatch();
  const { loading, visaDetail, error } = useSelector(
    (state) => state.visaDetail
  );

  useEffect(() => {
    dispatch(getVisaDetail({ id }));
  }, [dispatch, id]);

  const formatDate = (date) => {
    const options = {
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    };
    return date.toLocaleDateString("en-US", options);
  };

  useEffect(() => {
    const getDate = (deliverDays) => {
      const currentDate = new Date();
      let remainingDays = parseInt(deliverDays, 10);
      let deliveryDate = new Date(currentDate);

      // Loop until all deliverable days are counted
      while (remainingDays > 0) {
        deliveryDate.setDate(deliveryDate.getDate() + 1); // Move to the next day

        // Check if the day is not Saturday (6) or Sunday (0)
        if (deliveryDate.getDay() !== 6 && deliveryDate.getDay() !== 0) {
          remainingDays--; // Only count weekdays
        }
      }

      const formattedDate = formatDate(deliveryDate); // Format as needed
      return formattedDate;
    };

    const deliverDays = parseInt(visaDetail?.deliverDays, 10);

    if (!isNaN(deliverDays)) {
      setMinSelectableDate(getDate(deliverDays));
    }
  }, [visaDetail?.deliverDays]);

  return (
    <>
      {loading ? (
        <Loading />
      ) : error?.status === 404 || !departureDate || !minSelectableDate || currentTravel > numTravellers || currentTravel < 0 || isNaN(currentTravel) ? (
        <NotFound />
      ) : new Date(minSelectableDate) > new Date(departureDate) ? (
        <LinkExpired id={visaDetail.id}/>
      ) : (
        <div className="travellerNavigation__container">
          <div className="travellerNavigation">
            <Navigation page={"document"}></Navigation>
            <DocumentUpload
              key={currentTraveller}
              numOfTravellers={numOfTravellers}
              visaDetail={visaDetail}
              currentTraveller={currentTraveller}
              sessionId={sessionId}
              departureDate={departureDate}
              currency={selectedCurrency}
              minSelectableDate={minSelectableDate}
            />

            {/* {page === 'addOns' && <AddOns deliverDays={parseInt(visaDetail?.deliverDays, 10)} numOfAddOns={numOfAddOns} setNumOfAddOns={setNumOfAddOns} setPage={setPage} selectedCurrency={selectedCurrency} setAddOns={setAddOns}></AddOns>} */}
            <Information></Information>
          </div>
        </div>
      )}
    </>
  );
};

export default TravellerNavigation;